module.exports = __webpack_public_path__ + "static/img/005.1d81f951.png";